import { notify } from 'utils'
import { map, omit, concat, findIndex, set, kebabCase, trim, upperFirst, cloneDeep } from 'lodash'
import { http, queryString } from 'utils'


// User mutation imports.
import { SET_LIST, SET_SINGLE, SET_PAGINATION_DATA, ADD_LIST, ADD_SINGLE, REMOVE_LIST_ITEM, UPDATE_LIST_ITEM, SET_PROPERTY, SET_STATE_PROPERTY, SET_LIST_PROPERTY } from 'vx/mutations'

const crud = ({
    resource,
    parent = null,
    state = {},
    actions = {},
    mutations = {},
    getters = {},
    modules = {}
} = {}) => {

    if (!resource) {
        throw new Error('Resource name must be specified');
    }

    let api_path;
    api_path = `${resource}`



    //let api_path;



    return {

        modules: modules,

        namespaced: true,

        state : Object.assign({
            parent: parent,
            resource: resource,
            single: {},
            list: [],
            pagination: {}
        }, state),

        // Getters
        getters: Object.assign({

            getById: (state) => (id) => {
                return state.list.find(item => {
                  return item.id == id;
                })
            },

            resourceExists: (state) => state.resource.id !== null && state.resource.id !== undefined,

            uri (state, getters, rootState, rootGetters) {
                return (path) => {
                    let uri = ""

                    //Allow uri (resource names) to have multi level paths /one/two/ect
                    if (resource.indexOf('/') > -1) {
                        let parts = resource.split('/')
                        uri = kebabCase(parts.pop())
                        uri = parts.join('/')+'/'+uri
                    } else {
                        uri = kebabCase(resource)
                    }


                    // When references parent modules we pass the ":id" helper so we can set the path
                    // to the loaded resources ID. This lets us generate URIs for nested modules.
                    if (path === ':id') {
                        path = state.single.id
                    }

                    if (path !== undefined) {
                        uri = `${uri}/${trim(path, '/')}`
                    }

                    // If this module has a parent module we'll prefix its generated URI here, this
                    // continues to chain up parent modules until we get a fully generated URI.
                    if (state.parent !== null) {
                        uri = `${rootGetters[`${state.parent}/uri`](':id')}/${uri}`
                    }

                    return uri
                }
            }
        }, getters),


        actions : (Object.assign({

            /**
             * Get a list of items.
             */
            getList ({ commit, getters, state }, payload) {

                console.log(state.parent, getters.uri())


                commit(SET_LIST, [])
                commit(SET_PAGINATION_DATA, null)

                return http.get(`${getters.uri()}?${queryString(payload)}`).then((response) => {
                    if (response.data.hasOwnProperty('data')) {
                        commit(SET_LIST, response.data.data)
                    } else {
                        commit(SET_LIST, response.data)
                    }

                    if (response.data.hasOwnProperty('meta')) {
                        commit(SET_PAGINATION_DATA, response.data.meta)
                    } else {
                        commit(SET_PAGINATION_DATA, omit(response.data, 'data'))
                    }
                }).catch(function (error) {
                    if (error.response && error.response.status) {
                        notify.error("API Error: " + error.response.status + " <br> " + error.response.statusText)
                    }
                })
            },

            /**
             * Get a single Item
             * @param {*} param0
             * @param {*} id
             */
            getSingle ({ commit, getters }, id) {

                return http.get(getters.uri(id)).then((response) => {
                    if (response.data.hasOwnProperty('data')) {
                        commit(SET_SINGLE, response.data.data)
                    } else {
                        commit(SET_SINGLE, response.data)
                    }
                }).catch(function (error) {
                    if (error.response && error.response.status) {
                        notify.error("API Error: " + error.response.status + " <br> " + error.response.statusText)
                    }

                    throw error
              })
            },

            /**
             * Set a single item
             * @param {*} param0
             * @param {*} data
             */
            setSingle ({ commit }, data) {
                commit(SET_SINGLE, data)
                return true
            },

            /**
             * Set a single item
             * @param {*} param0
             * @param {*} data
             */
            setSingleFromList ({ commit, getters }, id) {
                commit(SET_SINGLE, getters.getById(id))
                return true
            },


            /**
             * Get next page of paginated data
             * @param {*} param0
             * @param {*} payload
             */
            getListForNextPage ({ commit, state, getters }, payload) {
                let page = 1

                if (state.pagination && state.pagination.current_page > 0) {
                  if (state.pagination.current_page === state.pagination.last_page) {
                    return Promise.reject('There are no more items to load.')
                  }

                  page = state.pagination.current_page + 1
                }

                return http.get(`${getters.uri()}?${queryString(payload)}&page=${page}`).then((response) => {

                    if (page > 1) {
                      commit(ADD_LIST, response.data.data)
                    } else {
                      commit(SET_LIST, response.data.data)
                    }

                    if (response.data.hasOwnProperty('meta')) {
                        commit(SET_PAGINATION_DATA, response.data.meta)
                    } else {
                        commit(SET_PAGINATION_DATA, omit(response.data, 'data'))
                    }

                    return response
                }).catch(function (error) {
                    if (error.response && error.response.status) {
                        notify.error("API Error: " + error.response.status + " <br> " + error.response.statusText)
                        throw new Error('No more results.')
                    }
                })
            },

            /**
             * Add a single item
             * @param {*} param0
             * @param {*} payload
             */
            addSingle ({ commit, getters }, payload ) {

                return http.post(`${getters.uri()}`, payload).then((response) => {

                    if (response.data.hasOwnProperty('data')) {
                        commit(SET_SINGLE, response.data.data)
                        //Also add this item to the list
                        commit(ADD_LIST, [response.data.data])
                    } else {
                        commit(SET_SINGLE, response.data)
                        //Also add this item to the list
                        commit(ADD_LIST, [response.data])
                    }

                    return response
                }).catch(function (error) {

                    if (error.response && error.response.status && error.response.status === 422) {
                        let message = "Form validation failed:<br>"

                        if (error.response.data && error.response.data.errors) {
                            Object.keys(error.response.data.errors).forEach((e) => {
                                message = message + `<br><strong>${_.upperFirst(e)}</strong>: ${error.response.data.errors[e]}`
                            });
                        }

                        notify.error(message)
                    }


                    else if (error.response) {
                      if (error.response.data.message) {
                        notify.error("API Error: " + error.response.status + " <br> " + error.response.data.message)
                      } else {
                        notify.error("API Error: " + error.response.status + " <br> " + error.response.statusText)
                      }
                    }

              })
            },

            /**
             * Update a single item
             * @param {*} param0
             * @param {*} param1
             */
            updateSingle ({ commit, getters }, {id, payload} ) {
                return http.put(`${getters.uri()}/${id}`, payload).then((response) => {

                    if (response.data.hasOwnProperty('data')) {
                        commit(SET_SINGLE, response.data.data)
                        //Also add this item to the list
                        commit(UPDATE_LIST_ITEM, [response.data.data])
                    } else {
                        commit(SET_SINGLE, response.data)
                        //Also add this item to the list
                        commit(UPDATE_LIST_ITEM, [response.data])
                    }

                    return response
                }).catch(function (error) {

                    if (error.response && error.response.status && error.response.status === 422) {
                        let message = "Form validation failed:<br>"

                        if (error.response.data && error.response.data.errors) {
                            Object.keys(error.response.data.errors).forEach((e) => {
                                message = message + `<br><strong>${_.upperFirst(e)}</strong>: ${error.response.data.errors[e]}`
                            });
                        }

                        notify.error(message)
                    }

                    else if (error.response) {
                      if (error.response.data.message) {
                        notify.error("API Error: " + error.response.status + " <br> " + error.response.data.message)
                      } else {
                        notify.error("API Error: " + error.response.status + " <br> " + error.response.statusText)
                      }
                    }

                    throw error
                })
            },

            /**
             * Add an item to the api and update the relating local record in our list.
             * @param {*} id
             * @param {*} payload
             */
            addListObject ({ commit, getters }, {payload} ) {

                return http.post(`${getters.uri()}`, payload).then((response) => {

                    if (response.data.hasOwnProperty('data')) {
                        commit(ADD_LIST, [response.data.data])
                    } else {
                        commit(ADD_LIST, [response.data])
                    }

                    return response
                }).catch(function (error) {

                    if (error.response && error.response.status && error.response.status === 422) {
                        let message = "Form validation failed:<br>"

                        if (error.response.data && error.response.data.errors) {
                            Object.keys(error.response.data.errors).forEach((e) => {
                                message = message + `<br><strong>${_.upperFirst(e)}</strong>: ${error.response.data.errors[e]}`
                            });
                        }

                        notify.error(message)
                    }

                    else if (error.response) {
                        notify.error("API Error: " + error.response.status + " <br> " + error.response.statusText)
                    }

                    throw error;
                })
            },

            /**
             * Update the item to the api and update the relating local record in our list.
             * @param {*} id
             * @param {*} payload
             */
            updateListObject ({ commit, getters }, {id, payload} ) {

                return http.put(`${getters.uri()}/${id}`, payload).then((response) => {

                    if (response.data.hasOwnProperty('data')) {
                        commit(UPDATE_LIST_ITEM, [response.data.data])
                    } else {
                        commit(UPDATE_LIST_ITEM, [response.data])
                    }

                    return response
                }).catch(function (error) {

                    if (error.response && error.response.status && error.response.status === 422) {
                        let message = "Form validation failed:<br>"

                        if (error.response.data && error.response.data.errors) {
                            Object.keys(error.response.data.errors).forEach((e) => {
                                message = message + `<br><strong>${_.upperFirst(e)}</strong>: ${error.response.data.errors[e]}`
                            });
                        }

                        notify.error(message)
                    }

                    else if (error.response) {
                        notify.error("API Error: " + error.response.status + " <br> " + error.response.statusText)
                    }
                })
            },

            /**
             * Delete the item to the api and update the relating local record in our list.
             * @param {*} id
             * @param {*} payload
             */
            deleteListObject ({ commit, getters }, {id, payload} ) {

                return http.delete(`${getters.uri()}/${id}`, payload).then((response) => {

                    commit(REMOVE_LIST_ITEM, id)

                    return response
                }).catch(function (error) {

                    if (error.response && error.response.status && error.response.status === 422) {
                        let message = "Form validation failed:<br>"

                        if (error.response.data && error.response.data.errors) {
                            Object.keys(error.response.data.errors).forEach((e) => {
                                message = message + `<br><strong>${_.upperFirst(e)}</strong>: ${error.response.data.errors[e]}`
                            });
                        }

                        notify.error(message)
                    }

                    else if (error.response) {
                        notify.error("API Error: " + error.response.status + " <br> " + error.response.statusText)
                    }
                })
            },

            /**
             * Delete a single item
             * @param {*} param0
             * @param {*} param1
             */
            deleteSingle ({ commit, getters }, id ) {

                return http.delete(`${getters.uri()}/${id}`).then((response) => {

                    commit(SET_SINGLE, {})

                    //Also remove this item from the list if we have a reference for it
                    commit(REMOVE_LIST_ITEM, id)

                    return response
              }).catch(function (error) {

                if (error.response && error.response.status && error.response.status === 422) {
                    let message = "Form validation failed:<br>"

                    if (error.response.data && error.response.data.errors) {
                        Object.keys(error.response.data.errors).forEach((e) => {
                            message = message + `<br><strong>${_.upperFirst(e)}</strong>: ${error.response.data.errors[e]}`
                        });
                    }

                    notify.error(message)
                }

                else if (error.response) {
                  if (error.response.data.message) {
                    notify.error("API Error: " + error.response.status + " <br> " + error.response.data.message)
                  } else {
                    notify.error("API Error: " + error.response.status + " <br> " + error.response.statusText)
                  }
                }
              })
          },
          setSingleProperty({ commit }, payload) {
            commit(SET_PROPERTY, payload)
          },

          /**
           *
           * @param {*} param0
           * @param {*} payload
           */
          setSingleListProperty({ commit }, payload) {
            commit(SET_LIST_PROPERTY, payload)
          },

          /**
           * Set a propery on the state object
           * @param {*} param0
           * @param {*} payload
           */
          setStateProperty({ commit }, payload) {
            commit(SET_STATE_PROPERTY, payload)
          },
          /**
           * Append items from local data instead of from remote API
           * @param {*} param0
           * @param {*} payload
           */
          addFromLocalToList({ commit }, payload) {
            commit(ADD_LIST, payload)
          },
          updateFromLocalToList({ commit }, data) {
            commit(UPDATE_LIST_ITEM, [data])
          },
          deleteFromLocalToList({ commit }, id) {
            commit(REMOVE_LIST_ITEM, id)
          },
          clearData({commit}, payload) {
            commit(SET_LIST, [])
            commit(SET_SINGLE, {})
          },
          resetSingle({commit}) {
            commit(SET_SINGLE, cloneDeep(state.initialState))
          }
        }, actions)),

        mutations : (Object.assign({

            /**
             * Set the list state
             * @param {*} state
             * @param {*} list
             */
            [SET_LIST] (state, list) {
              state.list = list
            },

            /**
             * Set the single state
             * @param {*} state
             * @param {*} single
             */
            [SET_SINGLE] (state, single) {
                state.single = single
            },

            /**
             * Add a single item to the state
             * @param {*} state
             * @param {*} single
             */
            [ADD_SINGLE] (state, single) {
                state.single = single
            },

            /**
             * Add more items to the list state
             * @param {*} state
             * @param {*} list
             */
            [ADD_LIST] (state, list) {
              state.list = concat(state.list, list)
            },

            /**
             * Update a single item in the list
             * @param {*} state
             * @param {*} item
             */
            [UPDATE_LIST_ITEM] (state, items) {
                items.forEach(item => {

                    let index = findIndex(state.list, existing => existing.id === item.id)

                    if (index === -1) {
                        state.list.push(item)
                    } else {
                        state.list.splice(index, 1, item)
                        //set(state.list, index, 1, item)
                    }
                })
              },

            /**
             * Remove a single item from the list
             * @param {*} state
             * @param {*} id
             */
            [REMOVE_LIST_ITEM] (state, id) {
              let existingItem = findIndex(state.list, existing => existing.id == id)

              if (existingItem >= 0) {
                state.list.splice(existingItem, 1)
              }
            },

            /**
             * Set the pagination data
             * @param {*} state
             * @param {*} pagination
             */
            [SET_PAGINATION_DATA] (state, pagination) {
              state.pagination = pagination
            },
            /**
             * Set a single property on the object currently in the state
             * @param {*} state
             * @param {*} param1
             */
            [SET_PROPERTY] (state, { property, value }) {
                set(state.single, property, value)
            },

            /**
             * Set a single property on the object currently in the state
             * @param {*} state
             * @param {*} param1
             */
            [SET_LIST_PROPERTY] (state, { id, property, value }) {

                let index = findIndex(state.list, existing => existing.id === id)

                if (index > -1) {
                    set(state.list[index], property, value)
                }
            },

            /**
             * Set a single property on the state object
             * @param {*} state
             * @param {*} param1
             */
            [SET_STATE_PROPERTY] (state, { property, value }) {
                set(state, property, value)
            }

          }, mutations))
    }
}

export default crud;
